<div class="oi-header-main box">
    <div class="oi-header-in-main">
    <div class="container-fluid">
    <div class="row">
    <div class="col-md-4 d-flex align-items-center oi-header-logo">
      <ng-container *ngIf="router.url === '/home' || router.url === '/data-insight'">
        <div class="logo"><img src="../../assets/img/logo-circle.svg"></div>
        <div class="logo-text">neInsight</div>
      </ng-container>
    </div>
    <div class="col-md-4">
    <!-- <div class="oi-header-search box d-flex justify-content-start">
    <div class="oi-head-serach-btn">
    <button type="button">
    <svg xmlns="http://www.w3.org/2000/svg" width="18.414" height="18.414" viewBox="0 0 18.414 18.414">
      <g id="Icon_feather-search" data-name="Icon feather-search" transform="translate(-3.5 -3.5)">
        <path id="Path_6" data-name="Path 6" d="M18.722,11.611A7.111,7.111,0,1,1,11.611,4.5,7.111,7.111,0,0,1,18.722,11.611Z" fill="none" stroke="#c0989c" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
        <path id="Path_7" data-name="Path 7" d="M28.842,28.842l-3.867-3.867" transform="translate(-8.342 -8.342)" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
      </g>
    </svg>
    
    </button>
    </div>
    <div class="oi-search-hd-main">
    <input type="text" class="oi-search1" id="fname" name="fname" placeholder="Search...">
    </div>
    </div> -->
    </div>
    <div class="col-md-4">
    <div class="oi-header-user-fltr">

    <div class="oi-apps-mn" *ngIf="router.url !== '/home'&& enableDataInsight">
      <div class="btn-group">
        <button type="button" class="btn btn-default oi-apps-btn dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="true">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <circle cx="5" cy="5" r="2"/><circle cx="12" cy="5" r="2"/><circle cx="19" cy="5" r="2"/>
            <circle cx="5" cy="12" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="19" cy="12" r="2"/>
            <circle cx="5" cy="19" r="2"/><circle cx="12" cy="19" r="2"/><circle cx="19" cy="19" r="2"/>
          </svg>
        </button>
        <div class="oi-apps-dropdown dropdown-menu dropdown-menu-end">
          <div class="oi-apps-panel">
            <p class="oi-apps-title">Your Favorites</p>
            <div class="oi-apps-grid">
              <a routerLink="/get-answer" class="oi-app-item">
                <div class="oi-app-icon"><img src="../../assets/img/knowledge-icon.png"></div>
                <span>KMS</span>
              </a>
              <a routerLink="/data-insight" class="oi-app-item">
                <div class="oi-app-icon"><img src="../../assets/img/database.svg"></div>
                <span>Data Insight</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="oi-user-mn">
    <div class="btn-group">
      <button type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
       <div class="user-avtar"><img src="../../assets/img/user.jpg"></div>
      </button>
      <div class="oi-userdrop-mn dropdown-menu">
      <div class="oi-usernewtop1">
      <div class="user-avtar"><img src="../../assets/img/user.jpg"></div>
      <div class="oi-usertop-text"><h4>{{this.username}}</h4>
        <p>{{this.email=== 'null' ? '' : this.email}}</p>
      </div>
      </div>
      
      <div class="oi-user-list">
      <ul>
      <li><a href="javascript:void(0)" (click)="logout()">Logout</a></li>
      </ul>
      </div>
      
      </div>
      
    
    </div>
    </div>
    
    </div>
    </div>
    
    
    </div>
    </div>
    </div>
    </div>